import { render, staticRenderFns } from "./yjbck.vue?vue&type=template&id=6e756413&scoped=true&"
import script from "./yjbck.vue?vue&type=script&lang=js&"
export * from "./yjbck.vue?vue&type=script&lang=js&"
import style0 from "./yjbck.vue?vue&type=style&index=0&id=6e756413&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e756413",
  null
  
)

export default component.exports